import { useTranslation } from 'react-i18next';
import { Navigate, useLocation } from 'react-router-dom';

import { DEFAULT_LANGUAGE, isSupportedLanguage } from '../../i18n/config';
import { localizePath } from '../../i18n/languagePath';

/**
 * "/" (x-default) : redirige vers la langue choisie précédemment, sinon celle du navigateur,
 * sinon le français.
 */
export default function LanguageRedirect() {
    const { i18n } = useTranslation();
    const { pathname, search, hash } = useLocation();
    const language = isSupportedLanguage(i18n.resolvedLanguage)
        ? i18n.resolvedLanguage
        : DEFAULT_LANGUAGE;

    return <Navigate to={`${localizePath(language, pathname)}${search}${hash}`} replace />;
}
